// extracted by mini-css-extract-plugin
export default {"container":"l0-z","list":"m0-z"};